import { AbstractStore } from "~/extensions/utils/AbstractStore";
import { reactive } from "vue";
import { Pagination } from "~/extensions/api";
import { AdminInformationFindConditionViewModel } from "~/pages/admin/Information/Models/AdminInformationFindConditionViewModel";
import { AdminInformationFindConditionValidator } from "~/pages/admin/Information/Models/AdminInfomationFindConditionValidator";
import Enumerable from "linq";
import { AdminInformationListViewModel } from "~/pages/admin/Information/Models/AdminInformationListViewModel";
import { adminApi } from "~/api/admin/Api";
class Store extends AbstractStore {
    get keyName() {
        return "startAt";
    }
    init() {
        this.condition = new AdminInformationFindConditionViewModel();
        this.storedCondition = new AdminInformationFindConditionViewModel();
        this.conditionValid = new AdminInformationFindConditionValidator(this.condition);
        this.defaultPagination = new Pagination("startAt,informationNo", true);
        this.resetPagination();
    }
    async load() {
        let result = await adminApi.adminInfomation.findAdmin(this.condition, this.pagination);
        this.results = Enumerable.from(result.records).select(x => new AdminInformationListViewModel(x)).toArray();
        this.pagination.rowsNumber = result.total;
        this.foundDate = result.executedDate;
    }
    clear() {
        super.clear();
    }
}
export let store = reactive(new Store());
